import React, {Component} from 'react'
import {connect} from 'react-redux'
import WithAjax from '../../common/helpers/WithAjax'
import {setJumbotronTitle} from '../../../actions/common'
import ClientAccountList from './ClientAccountList'

class ClientAccountManager extends Component {
  constructor() {
    super();
    this.fetchClientAccountData = this.fetchClientAccountData.bind(this);

    this.state = {
      items: []
    }
  }

  componentDidMount() {
    this.props.setJumbotronTitle('Client accounts');
    this.fetchClientAccountData();
  }

  fetchClientAccountData() {
    let url = 'clientaccounts';

    this.props.ajax.get(url, true, (data) => {
      data.forEach((el, index) => {
        return data[index].NavigationParam = data[index].Id;
      });
      this.setState({
        items: data
      })
    })
  }
  render() {
    return (
      <div>
        <ClientAccountList items={this.state.items} onReload={this.fetchClientAccountData} />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
})
const mapDispatchToProps = dispatch => ({
  setJumbotronTitle(title) { dispatch(setJumbotronTitle(title)) }
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(ClientAccountManager))
